import { render, staticRenderFns } from "./ReportsOverview.vue?vue&type=template&id=78a19ecc&scoped=true"
import script from "./ReportsOverview.vue?vue&type=script&lang=js"
export * from "./ReportsOverview.vue?vue&type=script&lang=js"
import style0 from "./ReportsOverview.vue?vue&type=style&index=0&id=78a19ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a19ecc",
  null
  
)

export default component.exports